import { mapEnumToOptions } from '@abp/ng.core';

export enum IntegrationState {
  OK = 0,
  Error = 1,
  Executing = 2,
  Pending = 3,
}

export const integrationStateOptions = mapEnumToOptions(IntegrationState);
